import React, { useMemo } from 'react'
import { strftime } from 'util/date'
import { getMatrixClient } from 'ducks/chat/utils/client'
import { isBotUser, isBridgeUser } from 'ducks/chat/utils/users'
import BaseAvatar from '../BaseAvatar'

const PRESENCE_STRINGS = {
  online: 'Online',
  offline: 'Offline',
  unavailable: 'Away',
}

export default function MemberAvatar(props) {
  const { mxEvent, presence, name: inputName, userId, avatarUrl } = props
  const { actionText, ...rest } = props
  const client = getMatrixClient()
  const isCurrentUser = client.getUserId() === userId
  const name = useMemo(
    () => {
      if (isBotUser(userId)) {
        return 'Bot'
      } else if (isBridgeUser(userId)) {
        // Note: we'll need to extend this when instagram comes along
        return 'Meta Business Suite'
      }
      return inputName
    },
    [inputName, userId]
  )
  const title = `${isCurrentUser ? 'You' : name} (${
    PRESENCE_STRINGS[presence]
  })`

  return (
    <>
      <BaseAvatar
        {...rest} // eslint-disable-line react/jsx-props-no-spreading
        presence={presence}
        title={title}
        name={name}
        idName={userId}
        url={avatarUrl}
      />
      <div className="mx_EventTile_memberInfo">
        <div className="mx_EventTile_avatarName">
          {name}
          {isCurrentUser && ' (You)'}
          {actionText && ` ${actionText}`}
        </div>
        {mxEvent && (
          <div className="mx_EventTile_avatarTime">
            {strftime('%H:%M', mxEvent.getTs())}
          </div>
        )}
      </div>
    </>
  )
}
